import { Line } from "../editLineCrossingsStore/editLineCrossingsStore";
import { metadataTagZonesColorArray } from "../../EditIMetadataTagZones/EditMetadataTagZonesUtils/metadataTagZonesColorArray";

// Use the same color palette as metadata tag zones
export const LINE_COLORS = metadataTagZonesColorArray;

/**
 * Get the next available line color that isn't already used by existing lines
 * @param existingLines - Array of existing lines
 * @returns A color string that isn't currently in use, or cycles through if all used
 */
export const getNextLineColor = (existingLines: Line[]): string => {
  const usedColors = existingLines.map((line) => line.color);

  // Find the first unused color
  for (const color of LINE_COLORS) {
    if (!usedColors.includes(color)) {
      return color;
    }
  }

  // If all colors are used, cycle based on the number of existing lines
  return LINE_COLORS[existingLines.length % LINE_COLORS.length];
};
